import { Box, IconButton, Tooltip, Typography } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { useState } from 'react';

const AddressField = ({ address, sx }: { address: string, sx?: object }) => {
  const [copied, setCopied] = useState(false);
  if (!address || typeof address !== 'string') return null;
  if (!address) return null;

  const shortAddress = `${address.slice(0, 8)}...${address.slice(-4)}`;

  const handleCopy = (e: React.MouseEvent) => {
    e.stopPropagation();
    navigator.clipboard.writeText(address);
    setCopied(true);
    setTimeout(() => setCopied(false), 1000);
  };

  return (
    <Box display="flex" alignItems="center" width="160px" justifyContent="space-between" sx={sx}>
      <Tooltip title={address}>
        <Typography variant="body2" noWrap>
          {shortAddress}
        </Typography>
      </Tooltip>
      <Tooltip title={copied ? 'Copied!' : 'Copy'}>
        <IconButton size="small" onClick={handleCopy} sx={{ ml: 1 }}>
          <ContentCopyIcon fontSize="small" />
        </IconButton>
      </Tooltip>
    </Box>
  );
};

export default AddressField;
